import React, { useEffect, useState } from 'react';
import { Upload, Spin, message, Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { api, LinkButton } from '@unicus/react-ui-kit';
import join from 'util/functions/join';
import { CloseCircleOutlined, LoadingOutlined } from '@ant-design/icons';

const UploadArchive = ({
  onChange,
  name,
  resource,
  extension = ['png', 'jpg'],
  type = 'image',
  displayDocument = '',
  params,
  onRemove,
  initialValue,
  disabled,
  placeholder
}) => {
  const [state, setState] = useState({
    loading: false,
    uri: initialValue
  });

  useEffect(() => {
    setState({ ...state, uri: initialValue });
  }, [initialValue]);

  const extractingExtension = (fileName) => {
    const text = fileName.match(/\.[0-9a-z]+$/i)[0];
    return text != null ? text : '';
  };

  const beforeUpload = (file) => {
    let isCorrectFormat = false;

    if (
      type === 'image' &&
      extension.includes(file.type.replace('image/', '').toLowerCase())
    ) {
      isCorrectFormat = true;
    } else if (
      extension.includes(extractingExtension(file.name).replace('.', ''))
    ) {
      isCorrectFormat = true;
    }

    if (!isCorrectFormat) {
      message.error(
        `É permitido somente arquivos com a extensão ${join(
          extension.map((c) => c.toUpperCase()),
          ', ',
          ' e '
        )}.`
      );
    }

    const isLt2M = file.size / 1024 / 1024 < 2;

    if (!isLt2M) {
      message.error('O tamanho do arquivo não pode ser superior a 2MB');
    }

    return isCorrectFormat && isLt2M;
  };

  const setArchive = (uri, response) => {
    setState({
      uri,
      loading: false
    });

    if (onChange) {
      onChange(response);
    }
  };

  const handleUploadChange = (info) => {
    if (info.file.status === 'uploading') {
      setState({ loading: true });
      return;
    }

    if (info.file.status === 'done') {
      let archive = '';

      if (type === 'image') {
        archive = info.file.response.result.uri;
      } else {
        archive = info.file.response.result;
      }

      setArchive(archive, info.file.response.result);
    }
  };

  const handleRemoveClick = () => {
    setArchive(null, null);

    if (onRemove) {
      onRemove();
    }
  };

  const handleOnRequest = (options) => {
    const data = new FormData();

    if (params) {
      Object.keys(params).forEach((key) => {
        data.set(key, params[key]);
      });
    }

    data.append(name, options.file);
    api.post(resource, data).then((res) => {
      if (!(res && res.errors)) {
        options.onSuccess(res.data, options.file);
      } else {
        message.error(
          'Ocorreu um erro inesperado ao processar sua solicitação'
        );
        setState({ ...state, loading: false });
      }
    });
  };

  const uploadButton = (
    <div>
      {state.loading ? (
        <LoadingOutlined />
      ) : (
        <div className="gx-flex-row gx-align-items-center gx-text-grey">
          {placeholder ? <span>{placeholder}</span> : null}
          <FontAwesomeIcon className="icon gx-m-2" icon="download" size="2x" />
        </div>
      )}
    </div>
  );

  const getContent = () => {
    const { uri } = state;

    if (!uri) {
      return uploadButton;
    }

    if (type === 'image') {
      return (
        <img
          src={`${process.env.REACT_APP_API_URL}/${uri}`}
          alt={name}
          style={{ width: '100%' }}
        />
      );
    }

    if (type === 'document') {
      return (
        <div>
          <span>{displayDocument || uri}</span>
        </div>
      );
    }

    return null;
  };

  const { uri } = state;

  return (
    <div
      className="gx-upload-archive-container"
      style={{
        width: 190,
        height: '100%',
        position: 'relative',
        paddingBottom: 10
      }}
    >
      {uri && !disabled && (
        <Button
          type="text"
          onClick={handleRemoveClick}
          style={{
            position: 'absolute',
            right: -2,
            top: 5,
            background: '#ff7373',
            width: 30,
            height: 30,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <CloseCircleOutlined className="gx-text-white" />
        </Button>
      )}
      <Upload
        name={name}
        listType="picture-card"
        className="gx-upload-archive"
        disabled={disabled}
        customRequest={handleOnRequest}
        beforeUpload={beforeUpload}
        onChange={handleUploadChange}
        data={params}
        showUploadList={false}
      >
        {getContent()}
      </Upload>
    </div>
  );
};

export default UploadArchive;
